import { AvatarProps, SvgIconProps } from "@mui/material";
import React from "react";
import { DisplayDynamicAvatarImage } from "./DisplayDynamicAvatarImage";
import Box from "@mui/material/Box";
import { StaticIcon } from "./StaticIcon";

export interface DisplayAvatarImageType {
  onlyFirstNameInitial?: boolean;
  showOnlineStatusBadge?: boolean;
  isOnline?: boolean;
  avatarSize?: number;
  staticIcon?: React.ComponentType<SvgIconProps>;
}

interface DisplayAvatarImageTypeProp
  extends DisplayAvatarImageType,
    AvatarProps {}

const DisplayAvatarImage = ({
  onlyFirstNameInitial = false,
  showOnlineStatusBadge = false,
  isOnline = false,
  staticIcon,
  avatarSize,
  ...avatarProps
}: DisplayAvatarImageTypeProp) => {
  return (
    <Box>
      {staticIcon ? (
        <StaticIcon icon={staticIcon} size={avatarSize ?? 40} />
      ) : (
        <DisplayDynamicAvatarImage
          src={avatarProps.src ?? ""}
          alt={avatarProps.alt ?? "avatar"}
          avatarSize={avatarSize ?? 40}
          isOnline={isOnline}
          showOnlineStatusBadge={showOnlineStatusBadge}
          onlyFirstNameInitial={onlyFirstNameInitial}
        />
      )}
    </Box>
  );
};

export default DisplayAvatarImage;
